import React from "react";
import Icon from "../../../../components/base/Icon";
import { FontAwesomeIcons } from "../../../../core/Types";
import { TrendKpi } from "../../models/AdminDashboardModel";

type Color = "primary" | "info" | "success" | "warning" | "danger" | "secondary";

type Props = {
    icon: FontAwesomeIcons
    color: Color
    label: string
    value: string | number
    trend?: TrendKpi
    secondary?: string
}

function formatNumber(n: number | string): string {
    if (typeof n === "string") return n;
    if (Math.abs(n) >= 1000000) return (n / 1000000).toFixed(1) + "M";
    if (Math.abs(n) >= 1000) return (n / 1000).toFixed(1) + "K";
    return n.toLocaleString();
}

function KpiCard(props: Props) {
    const trend = props.trend;
    const trendUp = trend?.trendUp ?? true;
    return (
        <div className="card kpi-card border-0 shadow-sm h-100">
            <div className="card-body d-flex align-items-center p-4">
                <div className={`kpi-icon-wrap bg-light-${props.color} me-3`}>
                    <Icon icon={props.icon} type="solid" className={`text-${props.color}`} size={20} />
                </div>
                <div className="flex-grow-1 min-w-0">
                    <div className="kpi-label text-truncate">{props.label}</div>
                    <div className="d-flex align-items-baseline flex-wrap">
                        <div className="kpi-value me-2">{formatNumber(props.value)}</div>
                        {trend && trend.previousValue !== undefined && (
                            <div className={`kpi-trend ${trendUp ? "up" : "down"}`}>
                                <Icon icon={trendUp ? "arrow-up" : "arrow-down"} type="solid" size={10} className="me-1" />
                                {Math.abs(trend.trendPercent).toFixed(1)}%
                            </div>
                        )}
                    </div>
                    {props.secondary && (
                        <div className="kpi-label text-truncate mt-1" style={{ fontSize: "0.75rem" }}>{props.secondary}</div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default KpiCard;
